export const iconsData = [

  {
    id: 1,
    name: "HTML",
    link: "https://i.imgur.com/HAEMOfs.png"
  },
  {
    id: 2,
    name: "CSS",
    link: "https://i.imgur.com/DlOwyEW.png"
  },
  {
    id: 3,
    name: "JavaScript",
    link: "https://i.imgur.com/rPiHLoL.png"
  },
  {
    id: 4,
    name: "Python",
    link: "https://i.imgur.com/cXjhD7g.png"
  },
  {
    id: 5,
    name: "Git",
    link: "https://i.imgur.com/xcwmW3l.png"
  },
  {
    id: 6,
    name: "Tailwind",
    link: "https://i.imgur.com/TLp1T8y.png"
  },
  {
    id: 7,
    name: "SCSS",
    link: "https://i.imgur.com/pc2kLoF.png"
  },
  {
    id: 8,
    name: "React",
    link: "https://i.imgur.com/ZqceVOl.png"
  },
  {
    id: 9,
    name: "Express",
    link: "https://i.imgur.com/YGWLNPr.png"
  },
  {
    id: 10,
    name: "Node",
    link: "https://i.imgur.com/hCpTgZm.png"
  },
  {
    id: 11,
    name: "SQL",
    link: "https://i.imgur.com/XQHVx2s.png"
  },
  {
    id: 12,
    name: "PostgreSQL",
    link: "https://i.imgur.com/vdGgsJe.png"
  }
]